<template>
  <v-container>
    <v-list-item
      v-for="(item, index) in noticeList"
      :key="index"
      link
      @click="clickNotice(item.link, item.type, item.uuid, item.is_read)"
    >
      <v-list-item-avatar>
        <v-img :src="item.image"></v-img>
      </v-list-item-avatar>
      <v-badge
        color="pink"
        dot
        :value="!item.is_read"
      >
      <v-list-item-content>
        <p>{{item.content}}</p>
        <p><small>{{noticeDate(item.created_at)}}</small></p>
      </v-list-item-content>
      </v-badge>
    </v-list-item>
  </v-container>
</template>
<script>

import dayjs from 'dayjs';
export default {
  name: 'NotificationListItem',
  props: ['noticeList', 'closeModal', 'parentComponent', 'setUnReadNotice'],
  methods: {
    noticeDate(created_at) {
      return dayjs(created_at).format("YYYY/MM/DD HH:mm");
    },
    clickNotice(link, type, uuid, isRead) {
      if (!isRead) {
        const param = {
          uuid: uuid
        };
        this.$axios.patch(process.env.VUE_APP_API_BASE_URL + '/notification', param)
          .then(() => {
            this.setUnReadNotice();
          })
      }
      if (type === 2) {
        if (window.confirm('トピック権限リクエストを承認しますか？')) {
          this.$router.push(link);
        }
      } else {
        this.$router.push(link);
      }
      // notificationModalだったらcloseModalを起動する
      if (this.parentComponent === 'NoticeList') {
        this.closeModal();
      }
    },
  }
}
</script>
